import React, { useEffect, useRef, useState } from "react";
import SucessMsgQb from "../SucessmsgQB/SucessMsgQb";
import axios from "../../../axios";
import ErrorDialog from "../../../Assesment/pages/Create_Assessment/create_published/ErrorDialogue";
const ConfirmPopUp = ({ close, questions, basicDetails, type }) => {
  const [success, setSuccess] = useState(false);
  const qbDialogRef = useRef(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [isGettingData, setIsGettingData] = useState(false);
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const dateHelper = (a) => {
    const inputDate = new Date(a);
    const month = inputDate.getMonth() + 1;
    const day = inputDate.getDate();
    const year = inputDate.getFullYear();
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const handleUpdateQB = async () => {
    setIsGettingData(true);
    if (type === "create") {
      console.log("basicDetails", basicDetails);
      let body = {
        name: basicDetails.name,
        standard_id: basicDetails.questionBankDetails.standard_id.id,
        subject_id: basicDetails.questionBankDetails.subject_id.id,
        teacher_id: Teacher_Json,
        section_id: basicDetails.questionBankDetails.section_id.id,
        questions: questions,
      };
      try {
        let res = await axios.post(`/api/v1/questionBank/create`, body);
        if (res.status === 201) {
          setSuccess(true);
          setIsGettingData(true)
          localStorage.removeItem("QBIMP");
        }
      } catch (error) {
        console.log("Error : ", error)
        setIsError(true);
        if (error.response.data.message) {
          setErrorMessage(error.response.data.message);
        }
        qbDialogRef.current.openDialog();
      }
      finally {
        setIsGettingData(false);
      }
    } else {
      let body = {
        name: basicDetails.name,
        standard_id: basicDetails.standard_id.id,
        subject_id: basicDetails.subject_id.id,
        teacher_id: Teacher_Json,
        section_id: basicDetails.section_id.id,
        deadline: dateHelper(basicDetails.deadline),
        questions: questions,
      };
      try {
        let res = await axios.put(
          `/api/v1/questionBank/update/${basicDetails.id}`,
          body
        );
        if (res.status === 200) {
          setSuccess(true);
          setIsGettingData(true)
          localStorage.removeItem("QBIMP");
        }
      } catch (error) {
        setIsError(true);
        if (error.response.data.message) {
          setErrorMessage(error.response.data.message);
        }
      } finally {
        setIsGettingData(false);
      }
    }
  };


  useEffect(() => {
    if (isError) {
      if (qbDialogRef.current) {
        qbDialogRef.current.openDialog();
      }
    }
  }, [isError]);

  return (
    <div className="published_Deative_transprant_body">
      {isGettingData ? (
        <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="Loading..." />
      ) : success ? (
        <SucessMsgQb details={basicDetails} />
      ) : (
        <div className="published_Deative_preview_container">
          <img
            className="deactive_closeBtn"
            src="/images/cross-circle3.svg"
            alt="close"
            onClick={() => close(false)}
          />
          <div className="col-12 deactivate_msg">
            {`Are you sure you want to save these questions in Question Bank?`}
          </div>
          <div className="row col-12 publish_deactive_btnBox">
            <button className="btn col-sm-5 my-1 deactive_sure_btn" onClick={handleUpdateQB}>
              Yes
            </button>
            <button className="btn col-sm-5 my-1 deactive_sure_btn" onClick={() => close(false)}>
              No
            </button>
          </div>
        </div>
      )}

      {isError && (
        <ErrorDialog
          error={"Cannot evaluate assessment!"}
          message={errorMessage}
          ref={qbDialogRef}
          setIsError={setIsError}
        />
      )}
    </div>
  );
};

export default ConfirmPopUp;
